export default {
  showActiveAlarmsOnly: 'Show active alarms only',
};
